import { generateRoutes } from '@/utils/generateRoutes'

export default {
    state: {
        isCollapse: false,//控制菜单的展开或收起
        menuList: [],
        menuItem: {},
        userInfo: {},
        isSelectedMenu: {},
        device: 'desktop'
    },
    mutations: {
        //修改菜单展开或收起方法
        collapseMenu(state,isCollapse) {
            state.isCollapse = isCollapse;
        },
        setMenuList(state, menuList) {
            state.menuList = menuList;
        },
        setMenuItem(state, menuItem) {
            state.menuItem = menuItem;
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        selectedMenu(state, selectedMenu) {
            state.isSelectedMenu = selectedMenu;
        },
        toggleDevice: (state, device) => {
            state.device = device
        }

    },
    actions: {
        updateCollapseMenu({ commit }, isCollapse) {
            commit('collapseMenu', isCollapse);
        },
        updateMenuList({ commit }, menuList) {
            commit('setMenuList', menuList);
        },
        updateMenuItem({ commit }, menuItem) {
            commit('setMenuItem', menuItem);
        },
        updatUserInfo({ commit }, userInfo) {
            commit('setUserInfo', userInfo);
        },
        updatToggleDevice({ commit }, device) {
            commit('toggleDevice', device)
        }
    }
}